import { useEffect, useRef, useState } from "react";
import { ShareEntityButton } from "@/shared/ui/ShareEntityDialog";

const STORAGE_KEY = "esh:floating-share-position";
const EDGE = 16;

interface Position {
  left: number;
  top: number;
}

const initialPosition = (): Position => ({
  left: EDGE,
  top: Math.max(EDGE, window.innerHeight - 92),
});

export const FloatingShareControl = (): JSX.Element => {
  const [position, setPosition] = useState<Position>(() => {
    try {
      const saved = window.localStorage.getItem(STORAGE_KEY);
      return saved ? JSON.parse(saved) as Position : initialPosition();
    } catch {
      return initialPosition();
    }
  });
  const dragging = useRef<{ offsetX: number; offsetY: number; moved: boolean } | null>(null);

  useEffect(() => {
    const onPointerMove = (event: PointerEvent): void => {
      const drag = dragging.current;
      if (!drag) return;
      drag.moved = true;
      setPosition({
        left: Math.min(Math.max(EDGE, event.clientX - drag.offsetX), window.innerWidth - 64),
        top: Math.min(Math.max(EDGE, event.clientY - drag.offsetY), window.innerHeight - 64),
      });
    };
    const onPointerUp = (): void => {
      if (!dragging.current) return;
      dragging.current = null;
      setPosition((next) => {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
        return next;
      });
    };
    window.addEventListener("pointermove", onPointerMove);
    window.addEventListener("pointerup", onPointerUp);
    return () => {
      window.removeEventListener("pointermove", onPointerMove);
      window.removeEventListener("pointerup", onPointerUp);
    };
  }, []);

  return (
    <div
      className="fixed z-[145] touch-none"
      style={{ left: position.left, top: position.top }}
      onPointerDown={(event) => {
        const rect = event.currentTarget.getBoundingClientRect();
        dragging.current = { offsetX: event.clientX - rect.left, offsetY: event.clientY - rect.top, moved: false };
      }}
    >
      <ShareEntityButton
        title={document.title || "eShendetesia"}
        path={`${window.location.pathname}${window.location.search}`}
        label="Ndaj faqen"
        className="h-12 w-12 rounded-full border-primary/30 bg-card shadow-xl hover:bg-primary hover:text-primary-foreground"
      />
    </div>
  );
};
